import { companyInfo, stats } from "../data/mock";
import { CheckCircle } from "lucide-react";

export const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-[#f8fafc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-[#ff9900] font-semibold text-sm uppercase tracking-wider">
              About Us
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0a2a43] mt-3 mb-6">
              Trusted Partner in
              <span className="text-[#ff9900]"> Automation</span>
            </h2>
            <p className="text-[#4a6680] text-lg leading-relaxed mb-8">
              {companyInfo.about}
            </p>

            <div className="space-y-4">
              {[
                "ISO-compliant manufacturing processes",
                "In-house design and testing facility",
                "Pan-India installation and support",
                "Custom solutions for unique requirements",
              ].map((point) => (
                <div key={point} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#ff9900]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <CheckCircle className="w-3.5 h-3.5 text-[#ff9900]" />
                  </div>
                  <span className="text-[#4a6680]">{point}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Stats */}
          <div className="grid grid-cols-2 gap-5">
            {stats.map((stat, index) => (
              <div
                key={stat.label}
                className={`bg-white rounded-2xl p-8 border border-[#e2e8f0] hover:border-[#ff9900]/30 hover:shadow-lg hover:shadow-[#ff9900]/5 transition-all duration-300 ${
                  index === 0 ? "lg:translate-y-4" : ""
                } ${
                  index === 3 ? "lg:-translate-y-4" : ""
                }`}
              >
                <div className="text-3xl sm:text-4xl font-bold text-[#0a2a43] mb-2">
                  {stat.value}
                </div>
                <div className="text-[#4a6680] text-sm font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
